/** Opzioni colore tag — palette allineata ai filtri ruolo (tema Blu). */
export const STUDIO_LABEL_COLOR_OPTIONS = [
  { id: 'muted', hex: '#64748b', label: 'Grigio' },
  { id: 'por', hex: '#a86a0b', label: 'Ambra' },
  { id: 'dif', hex: '#0e8f4f', label: 'Verde' },
  { id: 'lime', hex: '#65a30d', label: 'Lime' },
  { id: 'teal', hex: '#0d9488', label: 'Teal' },
  { id: 'cyan', hex: '#0891b2', label: 'Ciano' },
  { id: 'cen', hex: '#2e73b8', label: 'Blu' },
  { id: 'indigo', hex: '#4f46e5', label: 'Indaco' },
  { id: 'vio', hex: '#7c3aed', label: 'Viola' },
  { id: 'rose', hex: '#e11d48', label: 'Rosa' },
  { id: 'pink', hex: '#db2777', label: 'Pink' },
  { id: 'att', hex: '#c23a30', label: 'Rosso' },
];

export const STUDIO_LABEL_COLOR_PALETTE = STUDIO_LABEL_COLOR_OPTIONS.map((o) => o.hex);

export const DEFAULT_STUDIO_LABEL_COLOR = STUDIO_LABEL_COLOR_OPTIONS[0].hex;

export const STUDIO_LABEL_COLOR_COUNT = STUDIO_LABEL_COLOR_OPTIONS.length;

/** Normalizza un colore esadecimale (#rrggbb) o torna al default. */
export function normalizeLabelColor(value) {
  const raw = String(value || '').trim();
  if (/^#[0-9a-fA-F]{6}$/.test(raw)) {
    const lower = raw.toLowerCase();
    const exact = STUDIO_LABEL_COLOR_PALETTE.find((c) => c === lower);
    if (exact) return exact;
    return lower;
  }
  const fromPalette = STUDIO_LABEL_COLOR_PALETTE.find((c) => c.toLowerCase() === raw.toLowerCase());
  return fromPalette || DEFAULT_STUDIO_LABEL_COLOR;
}

export function getLabelColorOption(hex) {
  const normalized = normalizeLabelColor(hex);
  return STUDIO_LABEL_COLOR_OPTIONS.find((o) => o.hex === normalized) || STUDIO_LABEL_COLOR_OPTIONS[0];
}

/** Applica colore a chip / filtro tag (stesso schema --chip-color dei filtri ruolo). */
export function applyLabelChipColor(el, color) {
  if (!el) return;
  const hex = normalizeLabelColor(color);
  el.style.setProperty('--chip-color', hex);
  el.setAttribute('data-label-color', hex);
}

/** Picker colore a chip come i filtri ruolo. */
export function renderLabelColorPickerHtml(selectedColor, { compact = false, inputName = 'label-color' } = {}) {
  const selected = normalizeLabelColor(selectedColor);
  const chips = STUDIO_LABEL_COLOR_OPTIONS.map((opt) => {
    const on = opt.hex === selected;
    return `<button type="button" class="studio-label-color-chip studio-label-color-chip--${opt.id}${on ? ' is-selected' : ''}${compact ? ' studio-label-color-chip--compact' : ''}" data-color="${opt.hex}" style="--chip-color: ${opt.hex}" aria-label="${opt.label}" title="${opt.label}"><span class="studio-label-color-chip-dot" aria-hidden="true"></span></button>`;
  }).join('');
  return `<div class="studio-label-color-filters${compact ? ' studio-label-color-filters--compact' : ''}">
    <div class="studio-label-color-picker" role="radiogroup" aria-label="Colore tag" style="--label-color-cols: ${STUDIO_LABEL_COLOR_COUNT}">
      ${chips}
      <input type="hidden" class="studio-label-color-value" name="${inputName}" value="${selected}">
    </div>
  </div>`;
}

/** Sincronizza stato visivo del picker dopo click su un chip colore. */
export function syncLabelColorPickerSelection(picker, color) {
  const root = picker?.classList?.contains('studio-label-color-picker')
    ? picker
    : picker?.querySelector?.('.studio-label-color-picker');
  if (!root) return;
  const hex = normalizeLabelColor(color);
  const hidden = root.querySelector('.studio-label-color-value');
  if (hidden) hidden.value = hex;
  root.querySelectorAll('.studio-label-color-chip').forEach((btn) => {
    const on = btn.dataset.color === hex;
    btn.classList.toggle('is-selected', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}
